export const getters = {
  all: state => state.episodes,
  episode: state => id => state.episodes.find( e => e.episode_id === id ),
  tags: state => state.tags
}